export default __webpack_public_path__ + "static/media/Barlow-SemiBold.8247eaeb.ttf";